import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PageHeader } from '../components/PageHeader';
import { OfferCard } from '../components/OfferCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function MemberOffersPage() {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchOffers();
    }, []);

    const fetchOffers = async () => {
        try {
            const response = await axios.get(`${API}/offers`);
            // Filter to members-only offers
            const memberOffers = response.data.filter(o => o.audience === 'members');
            setOffers(memberOffers);
        } catch (error) {
            console.error('Error fetching offers:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container" data-testid="member-offers-page">
            <PageHeader title="Member Offers" showBack />
            
            <div className="px-4 py-4">
                <div className="card-base bg-accent/10 border-2 border-accent/30 mb-6">
                    <p className="text-foreground font-medium text-center">
                        Exclusive offers just for Friend of Burston members
                    </p>
                </div>

                {loading ? (
                    <div className="flex justify-center items-center py-12">
                        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
                    </div>
                ) : (
                    <div className="space-y-4" data-testid="member-offers-list">
                        {offers.length === 0 ? (
                            <div className="card-base text-center py-8">
                                <p className="text-muted-foreground">No member offers available at the moment.</p>
                            </div>
                        ) : (
                            offers.map(offer => (
                                <OfferCard key={offer.id} offer={offer} showFullDetails />
                            ))
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default MemberOffersPage;
